// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop_wrapper__XialU {
  height: 56px;
  border-bottom: 1px solid var(--mui-palette-grey-400);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  width: calc(100% - 64px);
  position: fixed;
  box-sizing: border-box;
  background: var(--mui-palette-primary-50);
  z-index: 1;
}

@media only screen and (max-width: 768px) {
  .desktop_wrapper__XialU {
    width: 100%;
  }
}

.desktop_searchWrapper__lhMG2 {
  width: 460px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/header/desktop.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oDAAoD;EACpD,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;AACd","sourcesContent":[".wrapper {\n  height: 56px;\n  border-bottom: 1px solid var(--mui-palette-grey-400);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  width: calc(100% - 64px);\n  position: fixed;\n  box-sizing: border-box;\n  background: var(--mui-palette-primary-50);\n  z-index: 1;\n}\n\n@media only screen and (max-width: 768px) {\n  .wrapper {\n    width: 100%;\n  }\n}\n\n.searchWrapper {\n  width: 460px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `desktop_wrapper__XialU`,
	"searchWrapper": `desktop_searchWrapper__lhMG2`
};
export default ___CSS_LOADER_EXPORT___;
